import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import PageStructure from 'flarum/forum/components/PageStructure';
import IndexSidebar from 'flarum/forum/components/IndexSidebar';
import Icon from 'flarum/common/components/Icon';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import humanTime from 'flarum/common/helpers/humanTime';
export function formatAmount(amount, currency) {
  const n = Number(amount) || 0;
  const str = n.toLocaleString('ru-RU', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  });
  const symbols = {
    RUB: '₽',
    USD: '$',
    EUR: '€',
    UAH: '₴',
    KZT: '₸',
    BYN: 'Br'
  };
  const sym = symbols[currency] || currency;
  return sym === '$' || sym === '€' ? `${sym}${str}` : `${str} ${sym}`;
}
export default class DonatePage extends Page {
  loading = true;
  donations = [];
  oninit(vnode) {
    super.oninit(vnode);
    app.history.push('nh.donate', app.translator.trans('neverhack-forum-nodes.lib.donate'));
    app.setTitle(String(app.translator.trans('neverhack-forum-nodes.forum.donate.title')));
    app.setTitleCount(0);
    const preloaded = app.preloadedApiDocument();
    if (preloaded) {
      this.donations = preloaded;
      this.loading = false;
    } else {
      app.store.find('nh-donations', {
        sort: '-donatedAt',
        page: {
          limit: 100
        }
      }).then(list => {
        this.donations = list;
        this.loading = false;
        m.redraw();
      });
    }
  }
  view() {
    return m(PageStructure, {
      className: "IndexPage NhDonatePage",
      hero: this.hero.bind(this),
      sidebar: this.sidebar.bind(this),
      loading: this.loading
    }, m("div", {
      className: "NhDonate"
    }, this.loading ? m(LoadingIndicator, null) : this.body()));
  }
  hero() {
    const url = app.forum.attribute('nhDonateUrl');
    const text = app.forum.attribute('nhDonateText');
    return m("header", {
      className: "Hero NhDonate-hero"
    }, m("div", {
      className: "container"
    }, m("h1", {
      className: "Hero-title"
    }, m(Icon, {
      name: "fas fa-heart"
    }), " ", app.translator.trans('neverhack-forum-nodes.forum.donate.title')), m("div", {
      className: "Hero-subtitle"
    }, text || app.translator.trans('neverhack-forum-nodes.forum.donate.default_text')), url ? m("a", {
      href: url,
      target: "_blank",
      rel: "noopener nofollow",
      className: "Button Button--primary NhDonate-button"
    }, m(Icon, {
      name: "fas fa-bolt"
    }), " ", app.translator.trans('neverhack-forum-nodes.forum.donate.button')) : m("p", {
      className: "NhDonate-noUrl"
    }, app.translator.trans('neverhack-forum-nodes.forum.donate.no_url'))));
  }
  sidebar() {
    return m(IndexSidebar, null);
  }
  body() {
    const visible = this.donations.filter(d => !d.isHidden());
    if (visible.length === 0) {
      return m("p", {
        className: "NhDonate-empty"
      }, app.translator.trans('neverhack-forum-nodes.forum.donate.empty'));
    }

    // Totals per currency.
    const totals = {};
    const byName = {};
    visible.forEach(d => {
      const cur = d.currency() || 'RUB';
      totals[cur] = (totals[cur] || 0) + (Number(d.amount()) || 0);
      const key = `${d.name().trim().toLowerCase()}|${cur}`;
      byName[key] ||= {
        name: d.name(),
        amount: 0,
        currency: cur,
        count: 0
      };
      byName[key].amount += Number(d.amount()) || 0;
      byName[key].count++;
    });
    const top = Object.values(byName).sort((a, b) => b.amount - a.amount).slice(0, 5);
    return m('[', null, m("div", {
      className: "NhDonate-stats"
    }, m("div", {
      className: "NhDonate-stat"
    }, m("span", {
      className: "NhDonate-statLabel"
    }, app.translator.trans('neverhack-forum-nodes.forum.donate.total')), m("span", {
      className: "NhDonate-statValue"
    }, Object.keys(totals).map(c => formatAmount(totals[c], c)).join(' + '))), m("div", {
      className: "NhDonate-stat"
    }, m("span", {
      className: "NhDonate-statLabel"
    }, app.translator.trans('neverhack-forum-nodes.forum.donate.count')), m("span", {
      className: "NhDonate-statValue"
    }, visible.length))), m("div", {
      className: "NhDonate-columns"
    }, m("section", {
      className: "NhDonate-section NhDonate-top"
    }, m("h3", {
      className: "NhDonate-heading"
    }, m(Icon, {
      name: "fas fa-trophy"
    }), " ", app.translator.trans('neverhack-forum-nodes.forum.donate.top')), m("ol", {
      className: "NhDonate-topList"
    }, top.map((t, i) => m("li", {
      className: `NhDonate-topItem NhDonate-topItem--${i + 1}`
    }, m("span", {
      className: "NhDonate-rank"
    }, "#", i + 1), m("span", {
      className: "NhDonate-name"
    }, t.name), m("span", {
      className: "NhDonate-amount"
    }, formatAmount(t.amount, t.currency)))))), m("section", {
      className: "NhDonate-section NhDonate-recent"
    }, m("h3", {
      className: "NhDonate-heading"
    }, m(Icon, {
      name: "fas fa-history"
    }), " ", app.translator.trans('neverhack-forum-nodes.forum.donate.recent')), m("ol", {
      className: "NhDonate-list"
    }, visible.map(d => m("li", {
      className: "NhDonate-item",
      key: d.id()
    }, m("div", {
      className: "NhDonate-itemMain"
    }, m("span", {
      className: "NhDonate-name"
    }, d.name()), m("span", {
      className: "NhDonate-amount"
    }, formatAmount(d.amount(), d.currency()))), d.message() && m("div", {
      className: "NhDonate-message"
    }, d.message()), m("div", {
      className: "NhDonate-time"
    }, d.donatedAt() ? humanTime(d.donatedAt()) : '')))))));
  }
}
flarum.reg.add('neverhack-forum-nodes', 'forum/components/DonatePage', DonatePage);